export default {
    namespaced: true,
    state: {
        delivery_list_id: null
    },
    mutations: {
        // 配信リストIDをセット
        setDeliveryListId(state, delivery_list_id) {
            state.delivery_list_id = delivery_list_id;
        }
    },
    actions: {},
    getters: {
        // 配信リストIDを取得
        getDeliveryListId(state) {
            return state.delivery_list_id;
        }
    }
};
